let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("6XPyJ")]).then(() => parcelRequire('8RcDd'));